import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import "./VentasAdmin.css";
import Permiso from "../../router/Permiso";
import { SaleService } from "../../services/SaleService";

const ListadoAvancesVentas = ({ token, refreshTrigger = 0 }) => {
    const [ventas, setVentas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [fechaInicio, setFechaInicio] = useState("");
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [fechaFin, setFechaFin] = useState("");
    const [buscarDNI, setBuscarDNI] = useState("");
    const [buscarNombre, setBuscarNombre] = useState("");


    const fetchVentas = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const { ventas, totalPaginas, totalRegistros } = await SaleService.fetchVentasAvances({
                token,
                pagina: currentPage,
                pageSize: 20,
                desde: fechaInicio,
                hasta: fechaFin,
                dni: buscarDNI,
                nombre: buscarNombre,
            });

            setVentas(ventas);
            setTotalPages(totalPaginas);
            setTotalRegistros(totalRegistros);
        } catch (err) {
            setError("Error al cargar las ventas");
            console.error("Error:", err);
        } finally {
            setLoading(false);
        }
    }, [token, currentPage, fechaInicio, fechaFin, buscarDNI, buscarNombre]);

    useEffect(() => {
        fetchVentas();
    }, [currentPage, fechaInicio, fechaFin, refreshTrigger, fetchVentas]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (buscarDNI || buscarNombre) {
                setCurrentPage(1);
                fetchVentas();
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [buscarDNI, buscarNombre, fetchVentas]);

    const exportarExcel = async () => {
        try {
            const filtros = {
                desde: fechaInicio,
                hasta: fechaFin,
                dni: buscarDNI,
                nombre: buscarNombre,
            };

            const blob = await SaleService.exportarVentasAvancesExcel(token, filtros);

            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "ventas_no_registradas.xlsx";
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error al exportar Excel:", error);
        }
    };

    return (
        <div className="ventas-admin-container">
            <div className="ventas-table-header">
                <h2 className="ventas-table-title">Listado de Ventas no Registradas</h2>
                <div className="productos-actions">
                    <Permiso permiso="export_ventas_no_registrada">
                        <button onClick={exportarExcel} className="btn-exportar">
                            Exportar a Excel
                        </button>
                    </Permiso>
                </div>
            </div>

            {/* Filtros */}
            <div className="usuarios-filtros">
                <div className="filtro-item">
                    <label htmlFor="fecha-inicio">Fecha Inicio:</label>
                    <input
                        type="date"
                        value={fechaInicio}
                        onChange={(e) => setFechaInicio(e.target.value)}
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor="fecha-fin">Fecha Fin:</label>
                    <input
                        type="date"
                        value={fechaFin}
                        onChange={(e) => setFechaFin(e.target.value)}
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor="codigo-cliente">Código del cliente:</label>
                    <input
                        type="text"
                        value={buscarDNI}
                        onChange={(e) => setBuscarDNI(e.target.value)}
                        placeholder="Ingrese código  del cliente"
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor="buscar-vendedor">Buscar por Vendedor:</label>
                    <input
                        type="text"
                        value={buscarNombre}
                        onChange={(e) => setBuscarNombre(e.target.value)}
                        placeholder="Nombre, apellido o nombre completo"
                    />
                </div>
                <div className="filtro-item">
                    <button onClick={fetchVentas} className="btn-filtrar">
                        Buscar
                    </button>
                </div>
                <div className="filtro-item">
                    <button
                        onClick={() => {
                            setFechaInicio("");
                            setFechaFin("");
                            setBuscarDNI("");
                            setBuscarNombre("");
                            setCurrentPage(1);
                            fetchVentas();
                        }}
                        className="btn-limpiar"
                    >
                        Limpiar Filtros
                    </button>
                </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            {loading ? (
                <div className="loading">Cargando ventas...</div>
            ) : (
                <>
                    <div className="ventas-table-wrapper">
                        <table className="ventas-table">
                            <thead>
                                <tr>
                                    <th>Codigo</th>
                                    <th>Fecha</th>
                                    <th>Hora</th>
                                    <th>Vendedor</th>
                                    <th>Supervisor</th>
                                    <th>Precio</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ventas.map((venta) => {
                                    return (
                                        <tr key={venta.id}>
                                            <td>
                                                {venta.cod_cliente
                                                    ? venta.cod_cliente.substring(0, 8) + "x".repeat(venta.cod_cliente.length - 8)
                                                    : ""}
                                            </td>

                                            <td >
                                                {new Date(venta.fecha_precliente).toLocaleDateString()}
                                            </td>
                                            <td>
                                                {venta.hora_precliente}
                                            </td>
                                            <td>
                                                {venta.nombre_vendedor} {venta.apellido_vendedor}
                                            </td>
                                            <td>{venta.supervisor}</td>
                                            <td className="ventas-acciones">
                                                {venta.precio_producto}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
                        {" "}
                        Total de registros: {totalRegistros}{" "}
                    </span>
                    {/* Paginación */}
                    <div className="pagination">
                        <button
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            Anterior
                        </button>
                        <span>
                            Página {currentPage} de {totalPages}
                        </span>
                        <button
                            onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            Siguiente
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

ListadoAvancesVentas.propTypes = {
  token: PropTypes.string.isRequired,
  refreshTrigger: PropTypes.number,
};

export default ListadoAvancesVentas;
